module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABQUlEQVQ4jZWTW2rCQBSGvxMHyTAYTbuCLsNV2A2I21CsCioYdBXiBnQLvgjupYpCGB8k6UM1TDRae97m57+cCyMAi8WiEcfxF/AOJDwvD/g2xoybzeZK5vN5w1q7/ENUWMaYT2Wt7bngfr8nTdMcUUTQWuP7fg6P47ingDdX3G63C9M2mw3r9ZparebCbwpn5mvyYDDI0tI0RUTodDoAbLdbt5PEK0rzfZ9SqYSIoJSiWq0ym82o1+tYa3NcVWRwPB6ZTCbZezqdcj6fc10+NQiCgH6/T5L8TlepVBCRIuprHQDZDl4yuO3A8zyCIHjd4HA4EEVRDnt03kKDcrlMt9u9wx4ZZKe8Lmo4HBaSXc6lPAXsgA+AMAyJoujuVK44DEMX2imt9eh0Oi2vohvC0zLGjATg8iP/9Z211uNWq7X6AfmVdrC4JzooAAAAAElFTkSuQmCC"


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/dl_datasource.png
 ** module id = 265
 ** module chunks = 0 1
 **/